import { Link } from 'react-router-dom';
import LegalPage, { Section } from './components/LegalPage';
import { CONTACT_EMAIL } from './constants';

function ContactEmail() {
  return (
    <a href={`mailto:${CONTACT_EMAIL}`} className="link hover:underline">
      {CONTACT_EMAIL}
    </a>
  );
}

function Contact() {
  return (
    <LegalPage title="Contact" lastUpdated={null}>
      <Section title="Get in touch">
        <p>
          Dissona is operated as a personal project. Questions, bug reports, feature requests and
          anything else are welcome at <ContactEmail />.
        </p>
        <p>
          We read every message, though replies may take a few days — this is not a staffed support
          desk.
        </p>
      </Section>

      <Section title="Account and content">
        <p>
          If something has gone wrong with a project — an upload that will not process, audio that
          never appears, a share that did not arrive — include the project title and roughly when it
          happened, and we will take a look.
        </p>
      </Section>

      <Section title="Privacy and data requests">
        <p>
          Requests about your personal data — access, correction, deletion, or a copy of what we
          hold — go to the same address. Most of these you can handle yourself from your settings
          page; see the <Link to="/privacy" className="link hover:underline">Privacy Policy</Link>{' '}
          for what we collect and what you are entitled to ask for.
        </p>
      </Section>

      <Section title="Copyright complaints">
        <p>
          If you believe content on Dissona infringes your copyright, write to <ContactEmail /> with
          enough detail to identify the material and your rights in it. See the{' '}
          <Link to="/terms" className="link hover:underline">Terms of Service</Link> for the
          rules everyone uploading content agrees to.
        </p>
      </Section>
    </LegalPage>
  );
}

export default Contact;
